/**
 *
 * Asynchronously loads the component for LoginFormV2
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { Loading } from 'components/Loading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "LoginFormV2" */),
  loading: <Loading />
})
